"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.setTemplateNameAndGC = exports.daProjectTypeNode = void 0;
const featureFlags_1 = require("../../../common/featureFlags");
const localizeUtils_1 = require("../../../common/localizeUtils");
const constants_1 = require("../../constants");
const create_1 = require("../../create");
const questionNames_1 = require("../../questionNames");
const CapabilityOptions_1 = require("./CapabilityOptions");
const ProjectTypeOptions_1 = require("./ProjectTypeOptions");
const teamsProjectTypeNode_1 = require("./teamsProjectTypeNode");
function daProjectTypeNode(parentValue = ProjectTypeOptions_1.ProjectTypeOptions.copilotAgentOptionId) {
    return {
        // project-type = Declarative Agent
        condition: { equals: parentValue },
        data: {
            name: questionNames_1.QuestionNames.Capabilities,
            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.copilotExtension.title"),
            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.copilotExtension.placeholder"),
            type: "singleSelect",
            staticOptions: [CapabilityOptions_1.DACapabilityOptions.declarativeAgent()],
            skipSingleOption: true,
        },
        children: [
            {
                condition: { equals: CapabilityOptions_1.DACapabilityOptions.declarativeAgent().id },
                data: {
                    name: questionNames_1.QuestionNames.WithPlugin,
                    title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.declarativeCopilot.title"),
                    cliDescription: "Whether to add API plugin for your declarative Copilot.",
                    type: "singleSelect",
                    staticOptions: CapabilityOptions_1.DACapabilityOptions.all(),
                    placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.declarativeCopilot.placeholder"),
                    onDidSelection: setTemplateNameAndGC,
                },
                children: [
                    {
                        condition: { equals: CapabilityOptions_1.DACapabilityOptions.withPlugin().id },
                        data: {
                            type: "singleSelect",
                            name: questionNames_1.QuestionNames.ActionType,
                            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.createApiPlugin.title"),
                            cliDescription: "API plugin type.",
                            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.addApiPlugin.placeholder"),
                            staticOptions: [
                                CapabilityOptions_1.ActionStartOptions.newApi(),
                                featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.KiotaNPMIntegration)
                                    ? CapabilityOptions_1.ActionStartOptions.apiSpecWithSearch()
                                    : CapabilityOptions_1.ActionStartOptions.apiSpec(),
                                ...(featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.DAMetaOS)
                                    ? [CapabilityOptions_1.ActionStartOptions.DAMetaOS()]
                                    : []),
                                CapabilityOptions_1.ActionStartOptions.existingPlugin(),
                            ],
                            default: CapabilityOptions_1.ActionStartOptions.newApi().id,
                            onDidSelection: CapabilityOptions_1.setTemplateName,
                        },
                        children: [
                            {
                                condition: { equals: CapabilityOptions_1.ActionStartOptions.newApi().id },
                                data: {
                                    type: "singleSelect",
                                    name: questionNames_1.QuestionNames.ApiAuth,
                                    title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.apiMessageExtensionAuth.title"),
                                    cliDescription: "The authentication type for the API.",
                                    placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.apiMessageExtensionAuth.placeholder"),
                                    staticOptions: [
                                        CapabilityOptions_1.ApiAuthOptions.none(false),
                                        CapabilityOptions_1.ApiAuthOptions.apiKey(),
                                        CapabilityOptions_1.ApiAuthOptions.microsoftEntra(),
                                        CapabilityOptions_1.ApiAuthOptions.oauth(),
                                    ],
                                    default: CapabilityOptions_1.ApiAuthOptions.none().id,
                                    onDidSelection: CapabilityOptions_1.setTemplateName,
                                },
                            },
                            featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.KiotaNPMIntegration)
                                ? (0, teamsProjectTypeNode_1.apiSpecWithSearchNode)()
                                : (0, teamsProjectTypeNode_1.apiSpecNode)((inputs) => inputs[questionNames_1.QuestionNames.ActionType] === CapabilityOptions_1.ActionStartOptions.apiSpec().id &&
                                    !featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.KiotaIntegration)),
                            {
                                condition: { equals: CapabilityOptions_1.ActionStartOptions.existingPlugin().id },
                                data: { type: "group", name: questionNames_1.QuestionNames.ImportPlugin },
                                children: [
                                    {
                                        data: (0, create_1.pluginManifestQuestion)(),
                                    },
                                    {
                                        data: (0, create_1.pluginApiSpecQuestion)(),
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    };
}
exports.daProjectTypeNode = daProjectTypeNode;
function setTemplateNameAndGC(selected, inputs) {
    (0, CapabilityOptions_1.setTemplateName)(selected, inputs);
    if (selected.id === CapabilityOptions_1.DACapabilityOptions.withGC().id) {
        inputs[questionNames_1.QuestionNames.ProgrammingLanguage] = constants_1.ProgrammingLanguage.TS;
    }
}
exports.setTemplateNameAndGC = setTemplateNameAndGC;
//# sourceMappingURL=daProjectTypeNode.js.map